import Image from 'next/image';

import type { TGift } from '~services/api/gifts/types';
import { ImageRenderer } from '~shared/ui/molecules';

import { FreeGift, GetFreeGift, Gift, OpenFeedMobileContainer } from './styles';

type TOpenFeedMobileProps = {
	gift?: TGift;
	free?: boolean;
	onClick: () => void;
};

export const OpenFeedMobile = ({
	gift,
	free,
	onClick,
}: TOpenFeedMobileProps) => {
	if (free) {
		return (
			<OpenFeedMobileContainer onClick={onClick}>
				<Image
					src="/img/neurons/gem-steroids.png"
					width={64}
					height={64}
					alt="open feed icon"
				/>
				<GetFreeGift />
			</OpenFeedMobileContainer>
		);
	}

	if (gift) {
		return (
			<div onClick={onClick}>
				<ImageRenderer
					item={gift.links}
					width={80}
					height={80}
					fallback={gift.image}
					alt="open feed icon"
				/>
				{!!gift.price ? <Gift /> : <FreeGift />}
			</div>
		);
	}

	return null;
};
